import { createReducer } from '@reduxjs/toolkit';

import { changeAutocompleteVisibility } from 'Core/actions/autocomplete.ts';
import { fromPayload } from 'Core/reducers/common.ts';

export default createReducer(false, (builder) => builder.addCase(changeAutocompleteVisibility, fromPayload));
